import { render } from "./RetentionCard.vue?vue&type=template&id=628bd93d&scoped=true"
import script from "./RetentionCard.vue?vue&type=script&lang=js"
export * from "./RetentionCard.vue?vue&type=script&lang=js"

import "./RetentionCard.vue?vue&type=style&index=0&id=628bd93d&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-628bd93d"]])

export default __exports__